export type ID = number | string;

export type ArrayElement<ArrayType extends readonly unknown[]> =
    ArrayType extends readonly (infer ElementType)[] ? ElementType : never;

export const NO_VALUE_PLACEHOLDER = 'N/A';